import _ from 'underscore';

function lambdaConvertForFinals(property, contain) {
  return (values = '') => {
    const formalizedValues = values.replace(/'/g, '\'\'');
    if (contain) {
      return `${property}/any(d:contains(d,'${formalizedValues}'))`;
    }

    return `${property}/any(d:contains(d,'${formalizedValues}') eq false)`;
  };
}

export function updateEntitySchemaForFinalUrls(entitySchema) {
  const entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties.FinalUrls = {
    name: 'FinalUrls',
    property: 'FinalUrls',
    operators: ['contains', 'doesnotcontain'],
    type: 'string',
    filterable: true,
  };

  entitySchemaCopy.properties.MobileFinalUrls = {
    name: 'MobileFinalUrls',
    property: 'MobileFinalUrls',
    operators: ['contains', 'doesnotcontain'],
    type: 'string',
    filterable: true,
  };

  return entitySchemaCopy;
}

export function updateOdataOptionsForFinalUrl(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    MobileFinalUrls: {
      contains: lambdaConvertForFinals('MobileFinalUrls', true),
      doesnotcontain: lambdaConvertForFinals('MobileFinalUrls', false),
    },
    FinalUrls: {
      contains: lambdaConvertForFinals('FinalUrls', true),
      doesnotcontain: lambdaConvertForFinals('FinalUrls', false),
    },
  });
  return optionsCopy;
}
